<div *ngIf="isAlertVisible" class="mx-auto max-w-prose">
  <div
    class="mb-4 rounded-xl bg-warning py-6 px-4 text-center text-sm text-apricot-1"
  >
    <p>
      Det finns tyvärr inga tider de närmaste 3 månaderna. Sök efter andra
      vårdgivare med lediga tider närmare i tiden:
    </p>
  </div>

  <app-ui-button
    (click)="redirectToSearchResults()"
    [expanded]="'block'"
    color="green"
  >
    Hitta andra vårdgivare
  </app-ui-button>
</div>
